import React, { FC } from 'react';
import Modal from '@uikit/Modal/Modal';
import { MessageModalProps } from '@src/modals/MessageModal/constants';

const MessageModal: FC<MessageModalProps> = ({
  title,
  content,
  closeModal,
  lob,
  hasButton = true,
  dataTestId,
}) => {
  return (
    <Modal
      title={title}
      closeClick={closeModal}
      needConfirm={false}
      className="message_modal"
      maxWidth="289px"
      dataTestId={`${dataTestId}-message-modal`}
    >
      <div
        className="message-modal"
        data-test-id={`${dataTestId}-message-modal`}
      >
        <div
          className="message-modal__grid"
          data-test-id={`${dataTestId}-message-modal-grid`}
        >
          {content}
        </div>
        {hasButton && (
          <div className="message-modal__bottom">
            <button
              onClick={closeModal}
              style={{ backgroundColor: lob ? '#4F7EFFFF' : '' }}
              data-test-id={`${dataTestId}-message-modal-save-ok-button`}
            >
              {lob ? 'Save' : 'OK'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default MessageModal;
